/**
 * The home's category disc clears with a "pop" when its tile is pressed (Monday 13378617969): up to
 * 118% over 80ms, then down to nothing and transparent over 200ms, the numeral fading in the first
 * 100ms of that. Pressing marks the category seen at once, so its count drops to 0 on the click itself —
 * the disc keeps showing the LAST number while it plays out. With reduced motion it goes at once.
 *
 * One rule on all three surfaces: iOS `CategoryBadgeClear.shown`, Android `CategoryBadgeClear.shown`.
 * The timing lives in `Home3Categories.module.css` (`badgeClear`).
 */
export function categoryBadgeShown(count: number, lastShown: number, reducedMotion: boolean): number | null {
  if (count > 0) return count;
  if (lastShown > 0 && !reducedMotion) return lastShown;
  return null;
}

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
